import React from 'react'
import { FaArrowLeft } from "react-icons/fa6";
import { IoMdShareAlt } from "react-icons/io";
import { GoPlusCircle } from "react-icons/go";
import formheadStyle from './formHead.module.css'
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

export default function FormHead() {
    const navigate = useNavigate();
    return (
        <>
            <div className={`${formheadStyle.formheadmainComponent} d-flex flex-wrap align-items-center`}>
                <div className="me-auto" onClick={() => navigate(-1)}>
                    <Link className={`${formheadStyle.formheadbackLink} d-flex flex-wrap align-items-center`}>
                        <FaArrowLeft className={`${formheadStyle.formheadbackIcon} me-2`} /> Back
                    </Link>
                </div>
                <div className='me-5'>
                    <Link className={`${formheadStyle.formheadshareLink} d-flex flex-wrap align-items-center`}>
                        <IoMdShareAlt className={`${formheadStyle.formheadshareIcon} me-2`} /> Share this author
                    </Link>
                </div>
                <Link className={`${formheadStyle.formheadaddLink} d-flex flex-wrap align-items-center`}>
                    <GoPlusCircle className={`${formheadStyle.formheadaddIcon} me-2`} /> Add author to event
                </Link>
            </div>
        </>
    )
}
